var W = { 0: 8203, 1: 8204, 2: 8205, 3: 8290, 4: 8291, 5: 8288, 6: 65279, 7: 8289, 8: 119155, 9: 119156, a: 119157, b: 119158, c: 119159, d: 119160, e: 119161, f: 119162 }, E = { 0: 8203, 1: 8204, 2: 8205, 3: 65279 }, w = { 0: String.fromCodePoint(E[0]), 1: String.fromCodePoint(E[1]), 2: String.fromCodePoint(E[2]), 3: String.fromCodePoint(E[3]) }, B = new Array(4).fill(String.fromCodePoint(E[0])).join(""), D = "\0";
function Q(e) {
  let n = JSON.stringify(e), c = new TextEncoder().encode(n), t = "";
  for (let s = 0; s < c.length; s++) {
    let o = c[s];
    t += w[o >> 6 & 3] + w[o >> 4 & 3] + w[o >> 2 & 3] + w[o & 3];
  }
  return B + t;
}
function H(e) {
  return !Number.isNaN(Number(e)) || /[a-z]/i.test(e) && !/\d+(?:[-:\/]\d+){2}(?:T\d+(?:[-:\/]\d+){1,2}(\.\d+)?Z?)?/.test(e) ? !1 : !!Date.parse(e);
}
function K(e) {
  try {
    new URL(e, e.startsWith("/") ? "https://acme.com" : void 0);
  } catch (n) {
    return !1;
  }
  return !0;
}
function Y(e, n, c = "auto") {
  return c === !0 || c === "auto" && (H(e) || K(e)) ? e : `${e}${Q(n)}`;
}
var N = Object.fromEntries(Object.entries(w).map((e) => [e[1], +e[0]])), F = Object.fromEntries(Object.entries(W).map((e) => e.reverse())), j = `${Object.values(W).map((e) => `\\u{${e.toString(16)}}`).join("")}`, b = new RegExp(`[${j}]{4,}`, "gu");
function G(e) {
  let n = e.match(b);
  if (n) return ee(n[0], !0)[0];
}
function ee(e, n = !1) {
  let c = Array.from(e);
  if (c.length % 2 === 0) {
    if (c.length % 4 || !e.startsWith(B)) return te(c, n);
  } else throw new Error("Encoded data has invalid length");
  let t = c.slice(4), s = new Uint8Array(t.length / 4);
  for (let r = 0; r < s.length; r++) s[r] = N[t[r * 4]] << 6 | N[t[r * 4 + 1]] << 4 | N[t[r * 4 + 2]] << 2 | N[t[r * 4 + 3]];
  let o = new TextDecoder().decode(s);
  if (n) {
    let r = o.indexOf(D);
    return r === -1 && (r = o.length), [JSON.parse(o.slice(0, r))];
  }
  return o.split(D).filter(Boolean).map((r) => JSON.parse(r));
}
function te(e, n) {
  var c;
  let t = [];
  for (let i = e.length * 0.5; i--; ) {
    let u = `${F[e[i * 2].codePointAt(0)]}${F[e[i * 2 + 1].codePointAt(0)]}`;
    t.unshift(String.fromCharCode(parseInt(u, 16)));
  }
  let s = [], o = [t.join("")], r = 10;
  for (; o.length; ) {
    let i = o.shift();
    try {
      if (s.push(JSON.parse(i)), n) return s;
    } catch (u) {
      if (!r--) throw u;
      let a = +((c = u.message.match(/\sposition\s(\d+)$/)) == null ? void 0 : c[1]);
      if (!a) throw u;
      o.unshift(i.substring(0, a), i.substring(a));
    }
  }
  return s;
}
function ne(e) {
  var n;
  return { cleaned: e.replace(b, ""), encoded: ((n = e.match(b)) == null ? void 0 : n[0]) || "" };
}
function T(e, n) {
  return Y(e, n);
}
function ue(e) {
  return Q(e);
}
function fe(e) {
  return G(e);
}
function le(e) {
  return ne(e);
}
var _, k;
function re() {
  if (k) return _;
  k = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString;
  return _ = function(t, s, o) {
    if (n.call(s) !== "[object Function]")
      throw new TypeError("iterator must be a function");
    var r = t.length;
    if (r === +r)
      for (var i = 0; i < r; i++)
        s.call(o, t[i], i, t);
    else
      for (var u in t)
        e.call(t, u) && s.call(o, t[u], u, t);
  }, _;
}
var P, U;
function oe() {
  if (U) return P;
  U = 1;
  var e = re();
  P = n;
  function n(c, t, s) {
    if (arguments.length === 3)
      return n.set(c, t, s);
    if (arguments.length === 2)
      return n.get(c, t);
    var o = n.bind(n, c);
    for (var r in n)
      n.hasOwnProperty(r) && (o[r] = n[r].bind(o, c));
    return o;
  }
  return n.get = function(t, s) {
    for (var o = Array.isArray(s) ? s : n.parse(s), r = 0; r < o.length; ++r) {
      var i = o[r];
      if (!(typeof t == "object" && i in t))
        throw new Error("Invalid reference token: " + i);
      t = t[i];
    }
    return t;
  }, n.set = function(t, s, o) {
    var r = Array.isArray(s) ? s : n.parse(s), i = r[0];
    if (r.length === 0)
      throw Error("Can not set the root object");
    for (var u = 0; u < r.length - 1; ++u) {
      var a = r[u];
      typeof a != "string" && typeof a != "number" && (a = String(a)), !(a === "__proto__" || a === "constructor" || a === "prototype") && (a === "-" && Array.isArray(t) && (a = t.length), i = r[u + 1], a in t || (i.match(/^(\d+|-)$/) ? t[a] = [] : t[a] = {}), t = t[a]);
    }
    return i === "-" && Array.isArray(t) && (i = t.length), t[i] = o, this;
  }, n.remove = function(c, t) {
    var s = Array.isArray(t) ? t : n.parse(t), o = s[s.length - 1];
    if (o === void 0)
      throw new Error('Invalid JSON pointer for remove: "' + t + '"');
    var r = n.get(c, s.slice(0, -1));
    if (Array.isArray(r)) {
      var i = +o;
      if (o === "" && isNaN(i))
        throw new Error('Invalid array index: "' + o + '"');
      Array.prototype.splice.call(r, i, 1);
    } else
      delete r[o];
  }, n.dict = function(t, s) {
    var o = {};
    return n.walk(t, function(r, i) {
      o[i] = r;
    }, s), o;
  }, n.walk = function(t, s, o) {
    var r = [];
    o = o || function(i) {
      var u = Object.prototype.toString.call(i);
      return u === "[object Object]" || u === "[object Array]";
    }, (function i(u) {
      e(u, function(a, l) {
        r.push(String(l)), o(a) ? i(a) : s(a, n.compile(r)), r.pop();
      });
    })(t);
  }, n.has = function(t, s) {
    try {
      n.get(t, s);
    } catch (o) {
      return !1;
    }
    return !0;
  }, n.escape = function(t) {
    return t.toString().replace(/~/g, "~0").replace(/\//g, "~1");
  }, n.unescape = function(t) {
    return t.replace(/~1/g, "/").replace(/~0/g, "~");
  }, n.parse = function(t) {
    if (t === "")
      return [];
    if (t.charAt(0) !== "/")
      throw new Error("Invalid JSON pointer: " + t);
    return t.substring(1).split(/\//).map(n.unescape);
  }, n.compile = function(t) {
    return t.length === 0 ? "" : "/" + t.map(n.escape).join("/");
  }, P;
}
var p = oe();
const se = ({
  pointer: e,
  mappings: n,
  data: c,
  hiddenStrings: t
}) => {
  const s = n[e];
  if (s) {
    delete n[e];
    const o = C(c, e);
    for (const r of o) {
      n[r] = s;
      const i = p.get(c, r), u = T(i, t);
      p.set(c, r, u);
    }
  } else {
    const o = C(c, e);
    for (const r of o) {
      const i = p.get(c, r), u = T(i, t);
      p.set(c, r, u);
    }
  }
};
function ce(e) {
  return "content" in e && !!e.content;
}
const C = (e, n = "") => {
  const c = [], t = p.get(e, n);
  if (ce(t))
    for (let s = 0; s < t.content.length; s++)
      t.content[s].nodeType === "text" ? c.push(`${n}/content/${s}/value`) : c.push(...C(e, `${n}/content/${s}`));
  return c;
}, L = ({
  entityId: e,
  entityType: n,
  space: c,
  environment: t,
  field: s,
  locale: o,
  editorInterface: r,
  fieldType: i,
  targetOrigin: u,
  platform: a
}) => {
  const d = {
    origin: "contentful.com",
    href: `${`${u || "https://app.contentful.com"}/spaces/${c}/environments/${t}`}/${n === "Entry" ? "entries" : "assets"}/${e}/?focusedField=${s}&focusedLocale=${o}&source=vercel-content-link`,
    contentful: {
      editorInterface: r,
      fieldType: i
    }
  };
  return a === "vercel" && delete d.contentful, d;
}, z = (e) => ["builtin", "sidebar-builtin", "editor-builtin"].includes(e), X = (e) => ie.includes(e);
function Z(e) {
  if (typeof structuredClone == "function")
    return structuredClone(e);
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (n) {
    return console.warn("Failed to clone data:", e, n), e;
  }
}
const ie = [
  "singleLine",
  "tagEditor",
  "listInput",
  "checkbox",
  "richTextEditor",
  "multipleLine"
];
function M(e, n, c, t, s, o, r) {
  const i = r ? n[r] : n;
  switch (e) {
    case "Symbol": {
      const u = T(i, c);
      p.set(t, s, u);
      break;
    }
    case "Text": {
      const u = T(i, c);
      p.set(t, s, u);
      break;
    }
    case "RichText": {
      se({
        pointer: "",
        mappings: o,
        data: i,
        hiddenStrings: c
      });
      break;
    }
    case "Array": {
      const u = i.map((a) => typeof a == "string" ? T(a, c) : a);
      p.set(t, s, u);
      break;
    }
  }
}
const de = (e, n, c) => {
  if (!e || !e.extensions || !e.extensions.contentSourceMaps)
    return console.error(
      "GraphQL response does not contain Content Source Maps information.",
      e
    ), e;
  const t = Z(e), {
    spaces: s,
    environments: o,
    editorInterfaces: r,
    fields: i,
    locales: u,
    entries: a,
    assets: l,
    mappings: m,
    fieldTypes: g
  } = t.extensions.contentSourceMaps, y = t;
  for (const d in m) {
    const { source: f } = m[d], h = "entry" in f ? a[f.entry] : l[f.asset], R = "entry" in f ? "Entry" : "Asset";
    if (!h)
      return t;
    const v = s[h.space], A = o[h.environment], x = h.id, S = i[f.field], I = u[f.locale], O = r[f.editorInterface], J = g[f.fieldType];
    if (!(z(O.widgetNamespace) && !X(O.widgetId)) && p.has(y, d)) {
      const V = p.get(y, d);
      if (V !== null) {
        const q = L({
          entityId: x,
          entityType: R,
          space: v,
          environment: A,
          field: S,
          locale: I,
          editorInterface: O,
          fieldType: J,
          targetOrigin: n,
          platform: c
        });
        M(J, V, q, y, d, m);
      }
    }
  }
  return t;
}, ae = [
  "nt_experiences",
  "nt_name",
  "nt_description",
  "nt_audience_id",
  "nt_rules",
  "nt_metadata",
  "nt_experience_id",
  "nt_type",
  "nt_config",
  "nt_audience",
  "nt_variants"
], $ = (e, n, c, t, s) => {
  if (!e.fields)
    return;
  const { contentSourceMaps: o } = e.sys;
  if (!o)
    return;
  const { mappings: r } = o;
  for (const i in r) {
    const { source: u } = r[i], a = e.sys.space.sys.id, l = e.sys.environment.sys.id, m = e.sys.id, g = e.sys.type, y = n[u.fieldType], d = c[u.editorInterface];
    if (z(d.widgetNamespace) && !X(d.widgetId))
      continue;
    const f = i.startsWith("/") ? i : `/${i}`;
    if (p.has(e, f)) {
      const h = p.get(e, f);
      if (h === null)
        return;
      const v = f.split("/").pop();
      if (!v) {
        console.error("Field name could not be extracted from the pointer", f);
        return;
      }
      if (ae.includes(v))
        continue;
      const A = e.sys.locale;
      if (A) {
        const x = L({
          entityId: m,
          entityType: g,
          space: a,
          environment: l,
          field: v,
          locale: A,
          editorInterface: d,
          fieldType: y,
          targetOrigin: t,
          platform: s
        });
        M(y, h, x, e, f, r);
      } else
        Object.keys(h).forEach((S) => {
          const I = L({
            entityId: m,
            entityType: g,
            space: a,
            environment: l,
            field: v,
            locale: S,
            editorInterface: d,
            fieldType: y,
            targetOrigin: t,
            platform: s
          });
          M(
            y,
            h,
            I,
            e,
            `${f}/${S}`,
            r,
            S
          );
        });
    }
  }
}, pe = (e, n, c) => {
  var s;
  const t = Z(
    e
  );
  if (t.sys && "items" in t) {
    const o = t;
    if (!((s = o.sys) != null && s.contentSourceMapsLookup))
      return o;
    const {
      contentSourceMapsLookup: { fieldTypes: r, editorInterfaces: i }
    } = o.sys, { items: u, includes: a } = o;
    u.forEach(
      (l) => $(l, r, i, n, c)
    ), a && a.Entry && a.Entry.forEach(
      (l) => $(l, r, i, n, c)
    ), a && a.Asset && a.Asset.forEach(
      (l) => $(l, r, i, n, c)
    );
  } else {
    const o = t;
    if (!o.sys.contentSourceMapsLookup)
      return console.error("Content source maps lookup data is missing"), o;
    $(
      o,
      o.sys.contentSourceMapsLookup.fieldTypes,
      o.sys.contentSourceMapsLookup.editorInterfaces,
      n,
      c
    );
  }
  return t;
};
export {
  ie as SUPPORTED_WIDGETS,
  Z as clone,
  T as combine,
  L as createSourceMapMetadata,
  fe as decode,
  ue as encode,
  pe as encodeCPAResponse,
  M as encodeField,
  de as encodeGraphQLResponse,
  se as encodeRichTextValue,
  z as isBuiltinNamespace,
  X as isSupportedWidget,
  le as splitEncoding
};
//# sourceMappingURL=index.js.map
